<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-amber-50 p-6">
    <Image
      :src="Logo"
      alt="Symphony"
      width="180"
      class="mb-8"
    />
    <h1 class="text-2xl font-medium text-gray-800 mb-2">
      Page not found
    </h1>
    <p class="text-gray-600 mb-6">
      The page you're looking for doesn't exist or has moved.
    </p>
    <div class="flex flex-wrap gap-3 justify-center">
      <Button
        label="Go home"
        icon="pi pi-home"
        class="p-button-outlined"
        @click="router.push('/')"
      />
      <Button
        label="Log in"
        icon="pi pi-sign-in"
        class="p-button-outlined"
        @click="router.push('/login')"
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Logo from '@/assets/logos/Symphony_Logo_Vertical_RGB.png';

const router = useRouter();
</script>
